<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">Contents</p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/Part1#P1">I. F<span class="small">ROM</span> S<span class="small">UBURB TO</span> C<span class="small">ITY</span></a></p>
<p class="toc1"><span href="#/Part2#P2" title="Link target outside of Sample">II. A G<span class="small">UIDE TO THE</span> N<span class="small">EIGHBORHOOD</span>’<span class="small">S</span> H<span class="small">ISTORY</span></span></p>
<p class="toc"><span href="#/Chapter1#C1" title="Link target outside of Sample">1. Florida Avenue NW (Boundary Street)</span></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Anna Julia Cooper Circle (LeDroit Circle)</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. T Street NW (Maple Avenue)</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. U Street NW (Spruce Street)</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Elm Street NW</span></p>
<p class="toc1"><span href="#/Part3#P3" title="Link target outside of Sample">III. E<span class="small">NVIRONS</span></span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Howard University</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Howardtown</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. M Street / Dunbar High School</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Griffith Stadium</span></p>
<p class="toc1"><span href="#/Afterword" title="Link target outside of Sample">Afterword: LeDroit Park Today</span></p>
<p class="toc"><span href="#/FurtherReading" title="Link target outside of Sample">Further Reading</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1dd3e3d0